import { Tabs, TabsContent, TabsList, TabsTrigger } from "@fieldbook/ui/tabs"
import { createFileRoute } from "@tanstack/react-router"
import { ArrowLeft } from "lucide-react"
import { NearbySpeciesList } from "./-components/NearbySpeciesList"
import { TargetSpeciesList } from "./-components/TargetSpeciesList"
import { RecordedSpeciesList } from "./-components/RecordedSpeciesList"
import {
  type SpeciesListTab,
  speciesListSearchSchema,
} from "./-utils/speciesListTabs"

export const Route = createFileRoute("/_private/projects/$id/data/species/")({
  component: RouteComponent,
  validateSearch: (search) => speciesListSearchSchema.parse(search),
})

function RouteComponent() {
  const { id } = Route.useParams()

  const navigate = Route.useNavigate()
  const { tab } = Route.useSearch()

  const handleTabChange = (tab: SpeciesListTab) => {
    navigate({
      to: "/projects/$id/data/species",
      params: { id },
      search: { tab },
      replace: true,
    })
  }

  return (
    <>
      <div className="mb-2 mt-2 space-y-2">
        <button
          onClick={() => navigate({ to: "/projects/$id/data", params: { id } })}
          className="text-muted-foreground flex items-center gap-1 text-sm focus-visible:outline-0"
        >
          <ArrowLeft size={12} />
          <span>All data</span>
        </button>
        <div className="flex w-full">
          <span className="text-muted-foreground text-lg">Species</span>
        </div>
      </div>
      <div className="flex flex-col">
        <Tabs
          value={tab}
          onValueChange={(val) => handleTabChange(val as SpeciesListTab)}
        >
          <TabsList className="bg-secondary-background w-full">
            <TabsTrigger value="recorded">Project Records</TabsTrigger>
            <TabsTrigger value="targeted">Target Species</TabsTrigger>
            <TabsTrigger value="nearby">Nearby</TabsTrigger>
          </TabsList>
          <TabsContent value="recorded">
            <RecordedSpeciesList />
          </TabsContent>
          <TabsContent value="targeted">
            <TargetSpeciesList />
          </TabsContent>
          <TabsContent value="nearby">
            <NearbySpeciesList />
          </TabsContent>
        </Tabs>
      </div>
    </>
  )
}
